// extracted by mini-css-extract-plugin
export default {"controlGrid":"AddAnnouncement_controlGrid__4AMaa","icon":"AddAnnouncement_icon__7RJJ0","labelText":"AddAnnouncement_labelText__U2Aq6"};